<script setup lang="ts">
import type { TpgClickEvent, TpgSelectEvent } from '@tpg/grammar-web';
import type { IconConstant } from '@tpg/grammar-web-icons';
import type { Slot } from 'vue';

export interface GrammarNavigationListItemProps {
  leadingIconTemplate?: IconConstant | '';
  trailingIconTemplate?: IconConstant | '';
  expanded?: boolean;
  selected?: boolean;
  subtitle?: string;
  label?: string;
  value?: string;
  selectedValue?: string;
}

interface GrammarNavigationListItemSlots {
  default?: Slot;
  badge?: Slot;
}

const props = withDefaults(defineProps<GrammarNavigationListItemProps>(), {
  leadingIconTemplate: '',
  trailingIconTemplate: '',
  expanded: false,
  selected: false,
  subtitle: '',
  label: '',
  value: '',
  selectedValue: '',
});

const emit = defineEmits<{
  click: [event: TpgClickEvent];
  select: [event: TpgSelectEvent];
}>();
const slots = defineSlots<GrammarNavigationListItemSlots>();

function onClick(event: TpgClickEvent): void {
  emit('click', event);
}

function onSelect(event: TpgSelectEvent): void {
  emit('select', event);
}
</script>

<template>
  <tpg-navigation-list-item
    v-bind="props"
    @tpg-click="onClick"
    @tpg-select="onSelect"
  >
    <div
      v-if="slots.badge"
      slot="badge"
      class="flex"
    >
      <slot name="badge" />
    </div>
    <slot />
  </tpg-navigation-list-item>
</template>
